import {UIAjaxWrapper} from '../../../shared/scripts/network/UIAjaxWrapper'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {UIPopupController} from '../../../shared/scripts/ui_popup/UIPopupController'
import {BaseStoreItem} from '../../../../shared/store/BaseStoreItem'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {UIAPIEndpoints} from '../../../shared/scripts/network/UIAPIEndpoints'
import {TranslationObject} from '@colonist/i18n'
import {BigId} from '@colonist/types'
import {ClientUserState} from '../ClientUserState'

export class UIStoreAjaxEndPoints {
    static async purchaseItem(item: BaseStoreItem, onSuccess?: (text: TranslationObject) => undefined, onFailure?: (text: TranslationObject) => undefined) {
        const urlVariable = `${item.category}/${item.type}`

        const response = await UIAjaxWrapper.postRequestHandler(`${UIAPIEndpoints.apiPayPurchaseItem()}/${urlVariable}`, undefined, undefined)
        if(response == undefined) throw new Error('Failed to purchase item')
        if(!response.isSuccess) return
        const json = response.json as AjaxDataTypes.PurchaseItemRequestStatus

        await ClientUserState.refresh()

        const title: TranslationObject = json.status ? {key: 'strings:storePage.success.success'} : {key: 'strings:popups.errors.general.title'}
        if(json.status) CA.sendGoogleAnalyticsEvent(CA.Category.Store, CA.Label.StoreSuccessfullyPurchasedItem)

        if(onSuccess && onFailure) {
            if(json.status) return onSuccess(json.message)
            return onFailure(json.message)
        }

        return UIPopupController.createSimplePopup(title, json.message)
    }

    static async activateGiftedMembership(itemId: BigId) {
        const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiActivateGiftMembership(), undefined, {itemId: itemId})
        if(response == undefined) return

        await ClientUserState.refresh()

        const title: TranslationObject = {key: 'strings:storePage.success.success'}
        const body: TranslationObject = {key: 'strings:storePage.sections.membership.activated'}

        return UIPopupController.createSimplePopup(title, body)
    }

    static async cancelGiftedMembership() {
        const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiCancelGiftMembership(), undefined, undefined)
        if(response == undefined) return

        await ClientUserState.refresh()
    }
}
